module.exports = __webpack_public_path__ + "media/images/survey_welcome_bg-08d63969251057fb9f5562407d6a5f39.png";